
import template from './map-definition-list.html';

/**
 * This is an example knockout component class. Note the export section at the end of the file.
 * @kind component
 * @class SampleComponent
 * @description Sample Component that shows the name value
 */
class MapDefinitionListViewModel {
	constructor(params) {
		this.params = params;

		this.selectedMapDefinition = ko_helper.safe_observable(params.selectedMapDefinition);
		this.refresh_observable = ko.observable(false);

		this.table_options = ko.observable({
			data_source: { schema: 'json_mapper', table: 'map_definition' },
			fields: [
				{ field: 'namespace', name: 'Namespace' },
				{ field: 'name', name: 'Name' },
				{ field: 'description', name: 'Description' },
				{ field: 'base_object', name: 'Base Object', type: 'json' }
			],
			actions: [
				{ label: 'Show JSON Map Fields', class: 'ps-btn-primary ps-btn-sm', icon_class: 'fa-regular fa-list', on_click: (row) => this.selectMapDefinition(row) },
				{ label: 'Edit JSON Map Definition', class: 'ps-btn-warning ps-btn-sm', icon_class: 'fa-regular fa-edit', on_click: (row) => this.editMapDefinition(row) },
				{ label: 'Delete JSON Map Definition', class: 'ps-btn-danger ps-btn-sm', icon_class: 'fa-regular fa-times', on_click: (row) => this.deleteMapDefinition(row) },
				{ label: 'Test JSON Map Definition', class: 'ps-btn-warning ps-btn-sm', icon_class: 'fa-regular fa-flask', on_click: (row) => this.testMapDefinition(row) }
			],
			allow_download: false,
			force_refresh: this.refresh_observable,
			sorting_options: {
				sortfield: 'namespace',
				sortorder: 'ASC'
			}
		});

		this.init();
	}

	async init() {
		// TODO: Pass local options to the table component, or add it to ps-table directly.
		let options = {};
		if (window.localStorage.getItem('json-mapper.map-definition.map-definition-list-options'))
			options = JSON.parse(window.localStorage.getItem('json-mapper.map-definition.map-definition-list-options'));
		else
			options = {
				fields: ['map_definition_id', 'namespace', 'name', 'description', 'base_object']
			};
	}

	update() {
		this.refresh_observable(true);
		this.selectedMapDefinition('');
	}

	async createMapDefinition() {
		let res = await Grape.dialog.open('AddEditMapDefinition', { mapDefinition: {} });
		if (res?.status === 'OK')
			this.update();
	}

	async editMapDefinition(data, event) {
		let res = await Grape.dialog.open('AddEditMapDefinition', { mapDefinition: data, edit: true });

		if (res?.status === 'OK')
			this.update();
	}

	selectMapDefinition(data, event) {
		this.selectedMapDefinition(data);
	}

	async deleteMapDefinition(data) {
		let confirm = await Grape.alerts.confirm({ type: 'warning', title: 'Delete', message: `Delete Map Definition <b>"${data.name}"</b>? This will affect any dependencies.`, cancel_type: 'default', accept_type: 'warning' });
		if (confirm)
		{
			let res = await Grape.fetches.deleteJSON('/api/json-map/definition', { map_definition_id: data.map_definition_id });
			if (res?.status === 'OK')
			{
				this.update();
				return res;
			}

			Grape.alerts.apiError(res);
		}
	}

	async testMapDefinition(data) {
		Grape.dialog.open('MapDefinitionTest', { mapDefinition: data });
	}
}

export default {
	name: 'map-definition-list',
	viewModel: MapDefinitionListViewModel,
	module_type: 'ko',
	template: template
};
